import { Flex } from '@chakra-ui/react';

import { ButtonIcon, Typography } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type ChatMessageEditProps = {
  onCancel: () => void;
};

export const ChatFormMessageEdit = ({ onCancel }: ChatMessageEditProps) => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Typography color="black" type="meta" fontWeight="medium">
        Edit message
      </Typography>
      <ButtonIcon
        aria-label="cancel chat edit"
        variant="ghost"
        data-testid="cancel-chat-edit-btn"
        onClick={onCancel}
      >
        <Icon
          name={iconNames.cross}
          height="12px"
          width="12px"
          stroke="var(--fgPrimary)"
        />
      </ButtonIcon>
    </Flex>
  );
};
